var map = {
	"./api.svg": 3896,
	"./arrow-down-small.svg": 4113,
	"./arrow-down.svg": 861,
	"./arrow-left.svg": 1169,
	"./arrow-right.svg": 5462,
	"./check.svg": 123,
	"./close.svg": 4614,
	"./command-line.svg": 1559,
	"./conversion.svg": 9828,
	"./copy-document.svg": 4897,
	"./copy.svg": 8072,
	"./download.svg": 270,
	"./duotone-align.svg": 8547,
	"./duotone-creditcard.svg": 6257,
	"./duotone-feather.svg": 34,
	"./duotone-hand.svg": 8892,
	"./duotone-heart.svg": 4898,
	"./duotone-help.svg": 2896,
	"./duotone-support.svg": 8749,
	"./file-pdf.svg": 8730,
	"./filter.svg": 1863,
	"./folder-watched.svg": 6969,
	"./heart.svg": 2108,
	"./help.svg": 6930,
	"./icon-api.svg": 5181,
	"./icon-asset-audio.svg": 4480,
	"./icon-asset-file.svg": 2039,
	"./icon-asset-images.svg": 783,
	"./icon-asset-text-documents.svg": 411,
	"./icon-asset-video.svg": 3140,
	"./icon-command-line.svg": 7167,
	"./icon-gui.svg": 5053,
	"./icon-linux.svg": 9473,
	"./icon-macos.svg": 1020,
	"./icon-shell-tool.svg": 1250,
	"./icon-watched-folder.svg": 8958,
	"./icon-web.svg": 3473,
	"./icon-windows-client.svg": 5300,
	"./icon-windows-desktop.svg": 5764,
	"./icon-windows-server.svg": 4222,
	"./icon-windows.svg": 5348,
	"./key.svg": 222,
	"./link-external.svg": 1844,
	"./link.svg": 9220,
	"./list.svg": 7418,
	"./login.svg": 7441,
	"./logo-angular.svg": 4017,
	"./logo-apple.svg": 6957,
	"./logo-discord.svg": 6742,
	"./logo-electron.svg": 7842,
	"./logo-facebook.svg": 2971,
	"./logo-instagram.svg": 3948,
	"./logo-linkedin.svg": 5540,
	"./logo-next.svg": 1770,
	"./logo-nuxt.svg": 6089,
	"./logo-pwa.svg": 9001,
	"./logo-react.svg": 3052,
	"./logo-ruby.svg": 2942,
	"./logo-svelte.svg": 8433,
	"./logo-twitter.svg": 5208,
	"./logo-typescript.svg": 5780,
	"./logo-vue.svg": 1894,
	"./logo-windows.svg": 4215,
	"./logo-xing.svg": 5270,
	"./logout.svg": 4230,
	"./mail-plane.svg": 915,
	"./mail.svg": 5297,
	"./menu.svg": 2466,
	"./minus.svg": 9262,
	"./plus.svg": 2342,
	"./quotes.svg": 2725,
	"./refresh.svg": 3308,
	"./sales.svg": 3525,
	"./sdk.svg": 7389,
	"./search.svg": 4343,
	"./spark.svg": 7904,
	"./viewer.svg": 3734,
	"./world.svg": 7374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;